<template>
  <div class="whole orders">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
       <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                       @current-change="pageChange" :total="totalNum" v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table :data="orders" style="width: 100%;margin-bottom: 20px;"
                  row-key="id" border default-expand-all
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="orderNumber" label="订单编号" width="220"/>
          <el-table-column prop="insertTime" label="下单时间" width="180"/>
          <el-table-column prop="money" label="消费金额" width="200"/>
          <el-table-column prop="storeMoney" label="门店成本" width="200"/>
          <el-table-column prop="userName" label="下单人" width="200"/>
          <el-table-column prop="storeName" label="下单店铺" width="200"/>
          <el-table-column prop="storeAddress" label="门店地址"/>
<!--          <el-table-column prop="payWay" label="支付方式"/>-->
          <el-table-column props='payWay' label="支付方式" width="200">
            <template slot-scope="scope">
              <div>{{getPayWay(scope)}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getStoreShortcutOrderList} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      token:window.localStorage.getItem("token"),
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      keywords:"",
      storeOrderType:"",

      orders:[]
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this._getList();
    }
  },
  methods: {
    pageChange (val) {
      this.pageNum = val
      this._getList()
    },
    getPayWay(scope){
      let payWay = scope.row.payWay;
      let obj = {1:"支付宝",2:"微信",3:"代金券"}
      return obj[payWay];
    },
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize,
        content: "",
        startDate: "",
        endDate: "",
        storeId: "",
      }
      loadingInstance(Loading)
      getStoreShortcutOrderList(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.totalNum = res.data.total
          this.orders = res.data.records.map(item=>{
            let oneOrder = {
              id:item.id,
              orderNumber:item.orderNumber,
              insertTime:item.insertTime,
              money:item.money,
              storeMoney:item.storeMoney,
              userName:item.userName,
              storeName:item.storeName,
              storeAddress:item.storeAddress,
              payWay:"",

              level:1
            }
            if(item.payRecordVos && item.payRecordVos.length>0){
              oneOrder.children = item.payRecordVos.map(c=>{
                return {
                  id:c.id,
                  orderNumber:c.orderNumber,
                  insertTime:c.insertTime,
                  money:c.money,
                  storeMoney:"",
                  userName:"",
                  storeName:"",
                  storeAddress:"",
                  payWay:c.payWay,

                  level:2
                }
              })
            }
            return oneOrder;
          })
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    }
  },
}
</script>
<style scoped>
.orders .product-img{
  width: 90px;
}

.user{
  z-index: 9;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #F8F8F8;
}
.userOperate{
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.userTable{
  padding: 10px;
  position: relative;
}
</style>
<style>
.orders table tr.el-table__row--level-0{
  background-color: #f7e7e7 !important;
}
.userOperate .el-input {
  width:180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width:100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/storeOrder/pageQuick.vue